import { render, staticRenderFns } from "./TxnStatus.vue?vue&type=template&id=790958aa&scoped=true&"
import script from "./TxnStatus.vue?vue&type=script&lang=js&"
export * from "./TxnStatus.vue?vue&type=script&lang=js&"
import style0 from "./TxnStatus.vue?vue&type=style&index=0&id=790958aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790958aa",
  null
  
)

export default component.exports